import { ILocale } from 'src/common/razzle-platform-translate/model'


/**
 * @description we use fonction to convert locale to locale_TERRITORY format
 * @param locale language to convert
 * @returns locale_TERRITORY format
 */
export const toLanguageTerritoryFormat = (locale: ILocale) => {
    switch (locale) {
        case 'de':
            return 'de_DE'
        case 'en':
            return 'en_US'
        case 'es':
            return 'es_ES'
        case 'fr':
            return 'fr_FR'
        case 'jp':
            return 'ja_JP'
        case 'pt':
            return 'pt_PT'
        case 'ru':
            return 'ru_RU'
        case 'sv':
            return 'sv_SE'
        case 'tr':
            return 'tr_TR'
        default:
            throw new Error(`${locale} is not handled`)
    }
}
